/**
 * Componente: Confirmación de cierre con cambios sin guardar.
 * Lo usan los formularios de carga (Padrón, Personal) cuando se intenta
 * cerrar con X o Cancelar y hay datos modificados. Mismo patrón visual que
 * ConfirmarAccionPersonalModal (nada de confirm() nativo).
 */

import React from 'react';
import { IconCerrar } from './icons';

const ConfirmarDescartarCambiosModal = ({ onSeguirEditando, onDescartar }) => (
  <div className="modal-overlay modal-overlay-confirmar-descarte">
    <div className="modal-content confirmar-eliminar-modal">
      <div className="modal-header">
        <h2>Hay cambios sin guardar</h2>
        <button type="button" className="modal-close" onClick={onSeguirEditando}><IconCerrar size={18} /></button>
      </div>

      <div className="modal-body">
        <p>Si cerrás ahora, se pierden los datos que cargaste o modificaste.</p>
      </div>

      <div className="modal-footer">
        <button type="button" className="btn-cancelar" onClick={onSeguirEditando} autoFocus>
          Seguir editando
        </button>
        <button type="button" className="btn-eliminar-confirmar" onClick={onDescartar}>
          Descartar cambios
        </button>
      </div>
    </div>
  </div>
);

export default ConfirmarDescartarCambiosModal;
